import { useTranslation } from 'react-i18next';
import { ReactComponent as ExpandIcon } from 'src/assets/tailwind/expand-icon.svg';
import { Icon } from 'src/components/ui/icon';
import { Typography } from 'src/components/ui/typography';
import type { SessionProgressCardProps } from 'src/content/DataLibrary/UploadSession/types';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';

const SessionProgressCard = ({
  activeSessionCount,
  progressPercent,
  estimatedTimeRemaining,
  onMaximize
}: SessionProgressCardProps) => {
  const { t } = useTranslation();

  return (
    <div className="tw:bg-primary tw:border tw:border-solid tw:border-border-secondary tw:rounded-2xl tw:flex tw:flex-col tw:w-full">
      <div className="tw:flex tw:items-center tw:justify-between tw:px-m tw:py-s">
        <Typography variant="h3" colorClass="tw:text-text-primary">
          {t(T.sessionsInProgress, { count: activeSessionCount })}
        </Typography>
        <button
          type="button"
          onClick={onMaximize}
          className="tw:flex tw:items-center tw:justify-center tw:p-s tw:rounded-full tw:cursor-pointer tw:border-none tw:bg-transparent hover:tw:bg-secondary"
        >
          <Icon
            icon={ExpandIcon}
            sizeClass="tw:h-[16px] tw:w-[16px]"
            colorClass="tw:text-icon-primary"
          />
        </button>
      </div>
      <div className="tw:flex tw:items-center tw:justify-center tw:px-m tw:py-s">
        <div className="tw:flex tw:flex-1 tw:flex-col tw:gap-s">
          <div className="tw:h-1.5 tw:w-full tw:rounded-full">
            <div className="tw:relative tw:h-1.5 tw:w-full tw:rounded-full tw:bg-border-secondary">
              <div
                className="tw:absolute tw:top-0 tw:left-0 tw:h-1.5 tw:rounded-full tw:bg-brand"
                style={{ width: `${progressPercent}%` }}
              />
            </div>
          </div>
          <div className="tw:flex tw:items-center tw:justify-between tw:w-full">
            <Typography variant="h6" colorClass="tw:text-text-primary">
              {progressPercent}%
            </Typography>
            {estimatedTimeRemaining ? (
              <Typography variant="b2" colorClass="tw:text-text-primary">
                {estimatedTimeRemaining}
              </Typography>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionProgressCard;
